import {Button, Card, css, styled} from '@mui/material';
import {StyledCardProps, StylesButtonProps} from './types';

const StyledCard = styled(Card)<StyledCardProps>`
	border: 1px solid transparent;
	flex-direction: column;
	padding: 16px;
	display: flex;
	height: 100%;

	${({onClick}) =>
		onClick &&
		css`
			cursor: pointer;
		`}

	${({selected, theme}) =>
		selected &&
		css`
			border-color: ${theme.palette.success.main};
		`}
`;

const StyledButton = styled(Button)<StylesButtonProps>`
	border-radius: 4px;
	padding: 8px;
	${({$selected, theme}) =>
		$selected &&
		css`
			background-color: ${theme.palette.success.shades['12p']};
		`}
`;

export {StyledCard, StyledButton};
